import makeStyles from "@mui/styles/makeStyles";

const panelSurface =
	"linear-gradient(180deg, var(--atl-surface-solid-strong) 0%, var(--atl-surface-solid) 100%)";
const innerSurface =
	"linear-gradient(180deg, var(--atl-surface-solid-muted) 0%, var(--atl-surface-solid) 100%)";
const selectedSurface =
	"linear-gradient(135deg, color-mix(in srgb, var(--company-color) 13%, var(--atl-surface-solid-strong)) 0%, color-mix(in srgb, var(--company-color-2) 10%, var(--atl-surface-solid)) 100%)";

const controls = {
	"& .MuiTextField-root, & .MuiFormControl-root, & .MuiAutocomplete-root": {
		width: "100% !important",
		marginTop: "0 !important",
		marginBottom: "0 !important",
		minWidth: 0,
	},
	"& .MuiAutocomplete-inputRoot": {
		width: "100% !important",
	},
	"& .MuiInputBase-root, & .MuiOutlinedInput-root, & .MuiAutocomplete-inputRoot": {
		borderRadius: "14px !important",
		background: "var(--atl-surface-solid) !important",
		backgroundColor: "var(--atl-surface-solid) !important",
		backgroundImage: "none !important",
		backgroundClip: "padding-box !important",
		color: "var(--atl-text) !important",
		backdropFilter: "none !important",
		WebkitBackdropFilter: "none !important",
	},
	"& .MuiOutlinedInput-notchedOutline": {
		borderColor: "var(--atl-border) !important",
	},
	"& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
		borderColor: "color-mix(in srgb, var(--atl-blue) 38%, var(--atl-border)) !important",
	},
	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
		borderColor: "var(--atl-blue) !important",
		borderWidth: "1px !important",
	},
	"& .MuiInputLabel-root": {
		color: "var(--atl-text-soft) !important",
		fontWeight: "800 !important",
		letterSpacing: "0 !important",
	},
	"& .MuiInputLabel-root.Mui-focused": {
		color: "var(--atl-blue) !important",
	},
	"& .MuiFormHelperText-root": {
		marginLeft: "0 !important",
	},
};

export const CompanyStyle = makeStyles((theme) => ({
	page: {},
	container: {
		position: "relative",
		zIndex: 1,
		paddingTop: theme.spacing(3),
		[theme.breakpoints.down("sm")]: {
			paddingTop: theme.spacing(2),
			paddingLeft: theme.spacing(1.5),
			paddingRight: theme.spacing(1.5),
		},
	},
	hero: {
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
		padding: theme.spacing(3),
		border: "1px solid var(--atl-border)",
		borderRadius: 24,
		color: "#fff",
		background:
			"linear-gradient(135deg, color-mix(in srgb, var(--atl-blue) 88%, #000 0%) 0%, color-mix(in srgb, var(--atl-teal) 84%, #000 0%) 100%)",
		boxShadow: "var(--atl-shadow-strong)",
		overflow: "hidden",
		position: "relative",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background:
				"radial-gradient(circle at 86% 18%, rgba(255,255,255,0.22), transparent 0 170px), linear-gradient(180deg, rgba(255,255,255,0.14), rgba(255,255,255,0))",
			pointerEvents: "none",
		},
		"& > *": {
			position: "relative",
			zIndex: 1,
		},
		[theme.breakpoints.down("sm")]: {
			alignItems: "stretch",
			flexDirection: "column",
			padding: theme.spacing(2.25),
		},
	},
	eyebrow: {
		marginBottom: theme.spacing(1),
		fontSize: 12,
		fontWeight: 900,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		opacity: 0.82,
	},
	heroTitle: {
		maxWidth: 780,
		color: "#fff",
		fontSize: 38,
		fontWeight: 900,
		lineHeight: 1.05,
		[theme.breakpoints.down("sm")]: {
			fontSize: 30,
		},
	},
	heroSubtitle: {
		maxWidth: 720,
		marginTop: theme.spacing(1.25),
		color: "rgba(255,255,255,0.8)",
		fontSize: 15,
		fontWeight: 650,
		lineHeight: 1.45,
	},
	heroStats: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(108px, 1fr))",
		gap: theme.spacing(1),
		minWidth: 390,
		[theme.breakpoints.down("md")]: {
			minWidth: 0,
			gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		},
		"@media (max-width: 460px)": {
			gridTemplateColumns: "1fr",
		},
	},
	heroStat: {
		padding: theme.spacing(1.25),
		border: "1px solid rgba(255,255,255,0.24)",
		borderRadius: 18,
		background: "rgba(255,255,255,0.12)",
		boxShadow: "inset 0 1px 0 rgba(255,255,255,0.18)",
	},
	statLabel: {
		color: "rgba(255,255,255,0.72)",
		fontSize: 12,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	statValue: {
		display: "block",
		maxWidth: 150,
		color: "#fff",
		fontSize: 20,
		fontWeight: 900,
		lineHeight: 1.05,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	contentShell: {
		display: "grid",
		gridTemplateColumns: "284px minmax(0, 1fr)",
		gap: theme.spacing(2),
		alignItems: "start",
		[theme.breakpoints.down("md")]: {
			gridTemplateColumns: "1fr",
		},
	},
	drawer: {
		position: "sticky",
		top: theme.spacing(1.5),
		display: "grid",
		gap: theme.spacing(1.25),
		padding: theme.spacing(1.5),
		border: "1px solid var(--atl-border)",
		borderRadius: 22,
		background: panelSurface,
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--atl-surface-solid-strong)",
		[theme.breakpoints.down("md")]: {
			position: "relative",
			top: 0,
		},
	},
	drawerHeader: {
		display: "grid",
		gap: 2,
	},
	drawerTitle: {
		color: "var(--atl-text)",
		fontSize: 15,
		fontWeight: 900,
		lineHeight: 1.2,
	},
	drawerSubtitle: {
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 700,
		lineHeight: 1.35,
	},
	drawerList: {
		display: "grid",
		gap: theme.spacing(0.75),
		paddingTop: theme.spacing(0.35),
		paddingBottom: theme.spacing(0.35),
		[theme.breakpoints.down("md")]: {
			gridAutoColumns: "minmax(238px, 1fr)",
			gridAutoFlow: "column",
			overflowX: "auto",
			scrollbarWidth: "none",
			"&::-webkit-scrollbar": {
				display: "none",
			},
		},
	},
	drawerItem: {
		"--company-color": "var(--atl-blue)",
		"--company-color-2": "var(--atl-teal)",
		display: "grid",
		gridTemplateColumns: "42px minmax(0, 1fr)",
		gap: theme.spacing(1),
		alignItems: "center",
		width: "100%",
		minWidth: 0,
		padding: theme.spacing(1),
		border: "1px solid var(--atl-border)",
		borderRadius: 16,
		color: "var(--atl-text)",
		background: innerSurface,
		boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
		cursor: "pointer",
		textAlign: "left",
		transition: "border-color 0.18s ease, background 0.18s ease, transform 0.18s ease",
		"&:hover": {
			transform: "translateY(-1px)",
			borderColor: "color-mix(in srgb, var(--company-color) 36%, var(--atl-border))",
		},
	},
	drawerItemSelected: {
		borderColor: "color-mix(in srgb, var(--company-color) 52%, var(--atl-border))",
		background: selectedSurface,
	},
	drawerIcon: {
		display: "grid",
		placeItems: "center",
		width: 42,
		height: 42,
		borderRadius: 14,
		color: "#fff",
		background: "linear-gradient(135deg, var(--company-color) 0%, var(--company-color-2) 100%)",
		boxShadow: "0 10px 22px color-mix(in srgb, var(--company-color) 24%, transparent)",
	},
	drawerItemTitle: {
		color: "var(--atl-text)",
		fontSize: 13,
		fontWeight: 850,
		lineHeight: 1.2,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	drawerItemMeta: {
		marginTop: 2,
		color: "var(--atl-text-soft)",
		fontSize: 11,
		fontWeight: 700,
		lineHeight: 1.25,
	},
	panel: {
		minWidth: 0,
		padding: theme.spacing(2),
		border: "1px solid var(--atl-border)",
		borderRadius: 22,
		background: panelSurface,
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--atl-surface-solid-strong)",
		...controls,
	},
	panelHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1.5),
		marginBottom: theme.spacing(1.5),
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
		},
	},
	panelTitle: {
		color: "var(--atl-text)",
		fontSize: 20,
		fontWeight: 900,
		lineHeight: 1.15,
	},
	panelSubtitle: {
		marginTop: 4,
		color: "var(--atl-text-soft)",
		fontSize: 13,
		fontWeight: 700,
		lineHeight: 1.35,
	},
	resultPill: {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		minHeight: 32,
		padding: theme.spacing(0.5, 1),
		borderRadius: 999,
		color: "var(--atl-text)",
		background: "var(--atl-surface-solid)",
		border: "1px solid var(--atl-border)",
		fontSize: 12,
		fontWeight: 850,
		whiteSpace: "nowrap",
	},
	formGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: theme.spacing(1.25),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	fullRow: {
		gridColumn: "1 / -1",
	},
	formGridMui: {
		...controls,
	},
	sectionStack: {
		display: "grid",
		gap: theme.spacing(1.25),
	},
	fieldSection: {
		display: "grid",
		gap: theme.spacing(1.5),
		padding: theme.spacing(1.65),
		borderRadius: 18,
		border: "1px solid var(--atl-border)",
		background: innerSurface,
		boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
		minWidth: 0,
		...controls,
	},
	fieldSectionHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	fieldSectionCopy: {
		minWidth: 0,
	},
	fieldSectionTitle: {
		color: "var(--atl-text)",
		fontSize: 14,
		fontWeight: 900,
		lineHeight: 1.2,
	},
	fieldSectionSubtitle: {
		marginTop: 3,
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 700,
		lineHeight: 1.35,
	},
	fieldSectionIcon: {
		display: "grid",
		placeItems: "center",
		width: 38,
		height: 38,
		flex: "0 0 auto",
		borderRadius: 14,
		color: "var(--atl-blue)",
		background: "color-mix(in srgb, var(--atl-blue) 10%, var(--atl-surface-solid))",
		border: "1px solid color-mix(in srgb, var(--atl-blue) 24%, var(--atl-border))",
	},
	fieldGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: theme.spacing(1.35),
		minWidth: 0,
		"& > *": {
			minWidth: 0,
		},
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	fieldGridThree: {
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		[theme.breakpoints.down("md")]: {
			gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		},
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	fieldGridFull: {
		gridColumn: "1 / -1",
	},
	legacyFormGrid: {
		marginTop: "0 !important",
		width: "100% !important",
		...controls,
		"& > .MuiGrid-item": {
			minWidth: 0,
		},
	},
	companySelectField: {
		width: "100% !important",
		minWidth: "0 !important",
		"& .MuiFormControl-root, & .MuiTextField-root, & .MuiAutocomplete-inputRoot": {
			width: "100% !important",
			minWidth: "0 !important",
		},
		"& .MuiInputBase-root": {
			borderRadius: "14px !important",
			background: "var(--atl-surface-solid) !important",
			color: "var(--atl-text) !important",
		},
		"& .MuiOutlinedInput-root": {
			background: "var(--atl-surface-solid) !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "var(--atl-border) !important",
		},
		"& .MuiInputBase-input": {
			background: "transparent !important",
		},
		"& .MuiInputLabel-root": {
			color: "var(--atl-text-soft) !important",
			fontWeight: "750 !important",
		},
	},
	actionRow: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: theme.spacing(1),
		marginTop: theme.spacing(1.5),
		paddingTop: theme.spacing(1.5),
		borderTop: "1px solid var(--atl-border)",
	},
	actionButton: {
		borderRadius: "999px !important",
		textTransform: "none !important",
		fontWeight: "850 !important",
	},
	userToolbar: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1fr) auto",
		gap: theme.spacing(1),
		alignItems: "center",
		marginBottom: theme.spacing(1.5),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	userGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(260px, 1fr))",
		gap: theme.spacing(1.25),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	userCard: {
		position: "relative",
		display: "grid",
		gridTemplateColumns: "46px minmax(0, 1fr)",
		gap: theme.spacing(1),
		alignItems: "start",
		minHeight: 134,
		padding: theme.spacing(1.35),
		border: "1px solid var(--atl-border)",
		borderRadius: 18,
		color: "var(--atl-text)",
		background: innerSurface,
		boxShadow: "inset 0 1px 0 var(--atl-surface-solid-strong)",
		cursor: "pointer",
		overflow: "hidden",
		textAlign: "left",
		transition: "transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease",
		"&:hover": {
			transform: "translateY(-2px)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 36%, var(--atl-border))",
			boxShadow: "var(--atl-shadow-strong)",
		},
	},
	userAvatar: {
		display: "grid",
		placeItems: "center",
		width: 46,
		height: 46,
		borderRadius: 14,
		color: "#fff",
		background: "linear-gradient(135deg, var(--atl-blue) 0%, var(--atl-teal) 100%)",
		fontSize: 15,
		fontWeight: 900,
		boxShadow: "0 10px 22px color-mix(in srgb, var(--atl-blue) 24%, transparent)",
	},
	userCardBody: {
		minWidth: 0,
	},
	userCardTop: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	userAlias: {
		color: "var(--atl-text)",
		fontSize: 15,
		fontWeight: 900,
		lineHeight: 1.2,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	statusPill: {
		display: "inline-flex",
		alignItems: "center",
		flex: "0 0 auto",
		padding: theme.spacing(0.35, 0.7),
		borderRadius: 999,
		color: "var(--atl-text)",
		background: "var(--atl-surface-solid)",
		border: "1px solid var(--atl-border)",
		fontSize: 11,
		fontWeight: 850,
		lineHeight: 1,
	},
	statusPillOnline: {
		color: "var(--atl-green)",
		borderColor: "color-mix(in srgb, var(--atl-green) 34%, var(--atl-border))",
	},
	userMeta: {
		marginTop: 4,
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 700,
		lineHeight: 1.35,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	rolePreview: {
		display: "flex",
		flexWrap: "wrap",
		gap: 5,
		marginTop: theme.spacing(1),
	},
	roleChip: {
		maxWidth: "100%",
		height: "24px !important",
		borderRadius: "999px !important",
		border: "1px solid color-mix(in srgb, var(--role-color) 42%, var(--atl-border)) !important",
		background: "color-mix(in srgb, var(--role-color) 12%, var(--atl-surface-solid)) !important",
		color: "var(--atl-text) !important",
		fontSize: "11px !important",
		fontWeight: "850 !important",
		"& .MuiChip-label": {
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
	},
	sectionCard: {
		display: "grid",
		gap: theme.spacing(1),
		padding: theme.spacing(1.25),
		borderRadius: 18,
		border: "1px solid var(--atl-border)",
		background: innerSurface,
	},
	factGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
		},
	},
	fact: {
		minWidth: 0,
		padding: theme.spacing(1),
		borderRadius: 16,
		border: "1px solid var(--atl-border)",
		background: innerSurface,
	},
	factLabel: {
		color: "var(--atl-text-soft)",
		fontSize: 11,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	factValue: {
		display: "block",
		marginTop: 3,
		color: "var(--atl-text)",
		fontSize: 13,
		fontWeight: 800,
		lineHeight: 1.25,
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	dialogContent: {
		display: "grid",
		gap: theme.spacing(1.5),
	},
	dialogRoles: {
		display: "flex",
		flexWrap: "wrap",
		gap: 6,
	},
	dialogActions: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: theme.spacing(1),
	},
	tableCard: {
		border: "1px solid var(--atl-border)",
		borderRadius: 18,
		background: innerSurface,
		overflow: "hidden",
		"& .MuiTableCell-root": {
			borderBottomColor: "var(--atl-border)",
			color: "var(--atl-text)",
			fontSize: 13,
		},
		"& .MuiTableHead-root .MuiTableCell-root": {
			color: "var(--atl-text-soft)",
			fontWeight: 900,
			textTransform: "uppercase",
			background: "var(--atl-surface-solid-muted)",
		},
	},
	emptyState: {
		display: "grid",
		placeItems: "center",
		minHeight: 160,
		padding: theme.spacing(3),
		borderRadius: 18,
		color: "var(--atl-text-soft)",
		background: innerSurface,
		border: "1px solid var(--atl-border)",
		fontSize: 14,
		fontWeight: 750,
		textAlign: "center",
	},
	skeletonCard: {
		height: 134,
		borderRadius: "18px !important",
		background: "var(--atl-surface-solid-muted) !important",
	},
	input: {
		textTransform: "uppercase",
	},
	capitalizeInput: {
		textTransform: "capitalize",
	},
}));
